import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { useTranslation } from 'react-i18next';

const ImageBox = styled(Box)(({ theme }) => ({
  backgroundImage: "url('./images/1.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  height: "100%",
  minHeight: 400,
  width: "100%",
  borderRadius: "20px",
  overflow: "hidden",
  position: "relative",
  [theme.breakpoints.down("md")]: {
    minHeight: 250,
  },
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "20px",
  },
}));

export default function MissionVisionSection() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';

  const fontFamily = isRTL
    ? "'Tajawal', Arial, sans-serif"
    : "Arial, Helvetica, sans-serif";

  const textAlign = isRTL ? 'right' : 'left';

  return (
    <Box
      sx={{
        backgroundColor: "lightgray",
        py: { xs: 6, md: 10 },
        px: { xs: 3, md: 8 },
        direction: isRTL ? 'rtl' : 'ltr',
        fontFamily,
      }}
    >
      <Grid container spacing={4} alignItems="center">
        {/* Left Image */}
        <Grid item md={6} xs={12}>
          <ImageBox />
        </Grid>

        {/* Right Text Section */}
        <Grid item md={6} xs={12}>
          <Box sx={{ px: { xs: 0, md: 4 }, textAlign }}>
           

            <Typography
              variant="h4"
              fontWeight="bold"
              gutterBottom
              color="#0C2182"
              sx={{ fontFamily }}
            >
              {t("vtitle")}
            </Typography>

            <Typography
              variant="body1"
              sx={{ color: "#374151", fontFamily }}
            >
              {t("vdes")}
            </Typography>

 <Typography
              variant="h4"
              fontWeight="bold"
              gutterBottom
              color="#0C2182"
              sx={{ fontFamily }}
            >
              {t("mtitle")}
            </Typography>

            <Typography
              variant="body1"
              sx={{ mb: 4, color: "#374151", fontFamily }}
            >
              {t("mdes")}
            </Typography>


          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
